<template>
	<div>

		<v-container fluid grid-list-xl py-0>
			<section-tooltip :title="$t('message.invoice')" ></section-tooltip>

			<app-card customClasses="mb-30">
				<v-select
				:items="eventGroups"
				v-model="eventGroup"
				box
				label="Event"></v-select> 
				<v-switch
					v-model="filterArticleTypes"
					label="Hide Parking, Coach, Chauffeur"
					color="primary"
					hide-details
					class="mt-3"
				></v-switch>
			</app-card>
			<app-card
				heading="Contractual revenue"
				customClasses="mb-30">
				<dx-data-grid
                    ref="contractualRevenueGrid"
                    :data-source="contractualRevenues"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="partner" caption="Partner" data-type="string" width="100%"/>
					<dx-column data-field="articleType" caption="Article type" data-type="string" alignment="right"/>
					<dx-column data-field="amount" data-type="number" caption="Amount" alignment="center" width="110"/>
                    <dx-column data-field="sumPriceNetto" caption="Price" :format="currencyFormat"/>
                    <dx-column data-field="sumPriceTotal" caption="Total" :format="currencyFormat" />
					<dx-summary>
						<dx-total-item
						column="amount"
						summary-type="sum"
						display-format="{0}"/>
						<dx-total-item
							column="sumPriceTotal"
							summary-type="sum"
							display-format="{0}"
							:value-format="currencyFormat"/>
					</dx-summary>
                </dx-data-grid>
			</app-card>
	
			<app-card
				heading="Revenue"
				customClasses="mb-30">
				<dx-data-grid
                    ref="revenueGrid"
                    :data-source="nonContractualRevenues"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="partner" caption="Partner" data-type="string" width="100%"/>
					<dx-column data-field="articleType" caption="Article type" data-type="string" alignment="right"/>
					<dx-column data-field="amount" data-type="number" caption="Amount" alignment="center" width="110"/>
                    <dx-column data-field="sumPriceNetto" caption="Price" :format="currencyFormat"/>
                    <dx-column data-field="sumPriceTotal" caption="Total" :format="currencyFormat" />

					<dx-summary>
						<dx-total-item
						column="amount"
						summary-type="sum"
						display-format="{0}"
						/>
						<dx-total-item
						column="sumPriceTotal"
						summary-type="sum"
						display-format="{0}"
						:value-format="currencyFormat"
						/>
					</dx-summary>
                </dx-data-grid>
			</app-card>
	
			<app-card
				heading="Revenue Totals"
				customClasses="mb-30">
				<dx-data-grid
                    ref="revenueTotalsGrid"
                    :data-source="totalRevenuesPerArticleType"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="articleType" caption="Article type" data-type="string" width="100%"/>
					<dx-column data-field="amount" data-type="number" caption="Amount" alignment="center" width="110"/>
                    <dx-column data-field="sumPriceNetto" caption="Price" :format="currencyFormat"/>
                    <dx-column data-field="sumPriceTotal" caption="Total" :format="currencyFormat" />

					<dx-summary>
						<dx-total-item
						column="amount"
						summary-type="sum"
						display-format="{0}"
						/>
						<dx-total-item
						column="sumPriceTotal"
						summary-type="sum"
						:value-format="currencyFormat"
						/>
					</dx-summary>
                </dx-data-grid>
			</app-card>


			<app-card
				heading="Costs"
				customClasses="mb-30">
				<dx-data-grid
                    ref="costsGrid"
                    :data-source="costsPerArticleType"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="articleType" caption="Article type" data-type="string" :calculate-cell-value="getNameCellValue" width="100%"/>
					<dx-column data-field="amount" data-type="number" caption="Amount" alignment="center" width="110"/>
                    <dx-column data-field="sumCosts" caption="Price" :format="currencyFormat"/>
                    <dx-column data-field="sumCostsTotal"  caption="Total" :format="currencyFormat" :calculate-cell-value="getTotalCellValue"/>

			
					<dx-summary>
		
						<dx-total-item
						column="amount"
						summary-type="sum"
						display-format="{0}"
						/>
						<dx-total-item
						column="sumCostsTotal"
						summary-type="sum"
						:value-format="currencyFormat"
						/>
					</dx-summary>
                </dx-data-grid>
				
			
				<v-layout row align-content-end justify-end class="text-xs-right">
					<v-flex xs12>
						<b>
							Total to be invoiced: {{totalInvoice | currency}}
						</b>
					</v-flex>
				</v-layout>
			</app-card>

			<app-card
				heading="Arrangement Fee"
				customClasses="mb-30">
				<dx-data-grid
                    ref="arrangementFeeGrid"
                    :data-source="arrangementFeePerType"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="type" caption="Type" data-type="string" width="100%"/>
					<dx-column data-field="description" data-type="string" caption="Description" alignment="left" />
                    <dx-column data-field="amount" caption="Amount" data-type="number" />
                    <dx-column data-field="total"  caption="Total" :format="currencyFormat" />

<!-- 			
					<dx-summary>
						<dx-total-item
						column="amount"
						summary-type="sum"
						display-format="{0}"/>
						<dx-total-item
						column="sumCostsTotal"
						summary-type="sum"
						:value-format="currencyFormat"/>
					</dx-summary> -->
                </dx-data-grid>
				
			
				<!-- <v-layout row align-content-end justify-end class="text-xs-right">
					<v-flex xs12>
						<b>
							Total to be invoiced: {{totalInvoice | currency}}
						</b>
						
					</v-flex>
				</v-layout> -->
			</app-card>

			<!-- <app-card
				heading="Commission"
				customClasses="mb-30">
				<dx-data-grid
                    ref="commissionGrid"
                    :data-source="commission"
                    :allow-column-reordering="false"
                    :headerFilter="{ visible:false }"
                    :row-alternation-enabled="true"
                    :show-column-lines="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :responsive="true"
                    :selection="{ mode: 'single' }">
					<dx-column data-field="type" caption="Type" data-type="string" width="100%"/>
                    <dx-column data-field="amount" caption="Amount" data-type="number" />
					<dx-column data-field="price" caption="Price" :format="currencyFormat" />
                    <dx-column data-field="total"  caption="Total" :format="currencyFormat" />
                </dx-data-grid>
			</app-card> -->
		

		</v-container>
	
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import WidgetRenderer from 'Components/Widgets/widget-renderer'
	import VueGridLayout from 'vue-grid-layout'
	import Enumerable from 'linq'

	export default {
		components: {

		},
		data() {
			return {
				eventGroup: null,
				filterArticleTypes: true,
				currencyFormat: {
					type: 'currency',
					precision: 2,
				},
				contractualRevenuesSum: 0,
				nonContractualRevenuesSum: 0,
				totalRevenuesPerArticleTypeSum: 0,
				costsPerArticleTypeSum: 0,
				totalRevenue: 0,
				totalInvoice: 0,
				contractualCostsSum: 0
			}
		},
		computed: {
			...mapGetters([
				'reportingData',
				'season'
			]),
			eventGroups: function () {
				if (this.reportingData.length > 0 && this.season) {
						const result = Enumerable.from(this.reportingData)
							.groupBy(`{Label: $.event_group_name, FromDate: $.fromDate}`, null, (key, g) => {
								return {
									event_group_name: key.Label,
									fromDate: key.FromDate,
								}
							}, '$.Label')
							.orderBy('$.fromDate')
							.select('$.event_group_name')
							.toArray()
					this.eventGroup = result[0]
					return result
				} else {
					return []
				}
			},
			contractualRevenues () {
							if (this.reportingData.length > 0 && this.eventGroup) {
					let query = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
						.where(item => item.is_contractual == true)
					
					if (this.filterArticleTypes) {
						query = query.where(item => item.FK_ArticleType === 1 || item.FK_ArticleType === 2)
					}

					return query
						.groupBy('{ Partner: $.wo_partner_name, ArticleType: $.article_type_name, PriceNetto: $.article_price_netto }', null, (key, g) => {
							return {
								partner: key.Partner,
								articleType: key.ArticleType,
								amount: g.sum(`$.Menge`),
								sumPriceNetto: key.PriceNetto,
								sumPriceTotal: g.sum(`$.sales_total`),
							}
						}, '$.Partner + $.ArticleType + $.PriceNetto')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()
				} else {
					return []
				}
			},
			nonContractualRevenues () {
				if (this.reportingData.length > 0 && this.eventGroup) {
					let query = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
						.where(item => item.is_contractual == false)
					
					if (this.filterArticleTypes) {
						query = query.where(item => item.FK_ArticleType === 1 || item.FK_ArticleType === 2)
					}

					return query
						.groupBy('{ Partner: $.wo_partner_name, ArticleType: $.article_type_name, PriceNetto: $.article_price_netto }', null, (key, g) => {
							return {
								partner: key.Partner,
								articleType: key.ArticleType,
								amount: g.sum(`$.Menge`),
								sumPriceNetto: key.PriceNetto,
								sumPriceTotal: g.sum(`$.sales_total`),
							}
						}, '$.Partner + $.ArticleType + $.PriceNetto')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()
				} else {
					return []
				}
			},
			totalRevenuesPerArticleType () {
				if (this.reportingData.length > 0 && this.eventGroup) {
					let query = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
						.where(item => item.is_contractual == false)
					
					if (this.filterArticleTypes) {
						query = query.where(item => item.FK_ArticleType === 1 || item.FK_ArticleType === 2)
					}

					return query
						.groupBy('{ ArticleType: $.article_type_name, IsContractual: $.is_contractual, PriceNetto: $.article_price_netto }', null, (key, g) => {
							const caption = key.IsContractual ? key.ArticleType + ' contractual' : key.ArticleType
							return {
								articleType: caption,
								amount: g.sum(`$.Menge`),
								sumPriceNetto: key.PriceNetto,
								sumPriceTotal: g.sum(`$.sales_total`),
							}
						}, '$.ArticleType + $.IsContractual + $.PriceNetto')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()
				} else {
					return []
				}
			},
			costsPerArticleType () {
				if (this.reportingData.length > 0 && this.eventGroup) {
					let query = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
					
					if (this.filterArticleTypes) {
						query = query.where(item => item.FK_ArticleType === 1 || item.FK_ArticleType === 2)
					}

					return query
						.groupBy('{ ArticleType: $.article_type_name, IsContractual: $.is_contractual, Costs: $.costs, ArticleName: $.article_name_short }', null, (key, g) => {
							return {
								articleType: key.ArticleType,
								isContractual: key.IsContractual,
								amount: g.sum(`$.Menge`),
								sumCosts: key.Costs,
								sumCommission: g.sum('$.commission'),
								sumContractualCommission: g.sum('$.contractualCommission'),
								sumCostsTotal: g.sum('$.costs_total'),
								articleName: key.ArticleName,
							}
						}, '$.ArticleType + $.IsContractual + $.Costs')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()
				} else {
					return []
				}
			},
			arrangementFeePerType () {
				if (this.reportingData.length > 0 && this.eventGroup) {
					let query = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
					
					if (this.filterArticleTypes) {
						query = query.where(item => item.FK_ArticleType === 1 || item.FK_ArticleType === 2)
					}

					const base = query
						.groupBy('{ ArticleType: $.article_type_name, IsContractual: $.is_contractual, Costs: $.costs, ArticleName: $.article_name_short }', null, (key, g) => {
							return {
								articleType: key.ArticleType,
								isContractual: key.IsContractual,
								amount: g.sum(`$.Menge`),
								sumCosts: key.Costs,
								sumCommission: g.sum('$.commission'),
								sumContractualCommission: g.sum('$.contractualCommission'),
								sumCostsTotal: g.sum('$.costs_total'),
								articleName: key.ArticleName,
							}
						}, '$.ArticleType + $.IsContractual + $.Costs')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()

					const nonContractualCosts = base
						.filter(item => item.isContractual == 0)
						.map(item => item.amount * item.sumCosts)
						.reduce((a, b) =>  a + b, 0)

					const nonContractualAmount = base
						.filter(item => item.isContractual == 0 && (item.articleType == '2Days' || item.articleType == '3Days'))
						.map(item => item.amount)
						.reduce((a, b) =>  a + b, 0)

					const agencyPassthrough = query
						.select(item => Number(item.agency_value || 0))
						.sum()
					const result = []

					result.push({
						type: 'Sales',
						description: 'Non contractual sales',
						amount: '',
						total: this.nonContractualRevenuesSum
					})

					result.push({
						type: 'Costs',
						description: 'Non contractual costs',
						amount: '',
						total: nonContractualCosts
					})

					result.push({
						type: 'Agency passthrough',
						description: 'Passed on to agencies',
						amount: '',
						total: agencyPassthrough
					})

					result.push({
						type: 'Arrangement Fee ',
						description: '',
						amount: '',
						total: this.nonContractualRevenuesSum - nonContractualCosts - agencyPassthrough
					})
					return result
				} else {
					return []
				}
			},
			commission () {
				if (this.reportingData.length > 0 && this.eventGroup) {
					const base = Enumerable.from(this.reportingData)
						.where(item => item.wo_status  === 2)
						.where(item => item.article_is_delivery  === 0)
						.where(item => item.event_group_name  === this.eventGroup)
						.where(item => item.wo_partner_name !== null && item.wo_partner_name !== '')
						.groupBy('{ ArticleType: $.article_type_name, IsContractual: $.is_contractual, Costs: $.costs, ArticleName: $.article_name_short }', null, (key, g) => {
							return {
								articleType: key.ArticleType,
								isContractual: key.IsContractual,
								amount: g.sum(`$.Menge`),
								sumCosts: key.Costs,
								sumCommission: g.sum('$.commission'),
								sumContractualCommission: g.sum('$.contractualCommission'),
								sumCostsTotal: g.sum('$.costs_total'),
								articleName: key.ArticleName,
							}
						}, '$.ArticleType + $.IsContractual + $.Costs')
						.orderBy('$.partner')
						.thenBy('$.articleType')
						.toArray()

					const contractualCosts = base
						.filter(item => item.isContractual == 1 && (
							item.articleType == '1Day' ||
							item.articleType == '2Days' ||
							item.articleType == '3Days' ||
							item.articleType == 'Parking' ||
							item.articleType == 'Coach' ||
							item.articleType == 'Chauffeur' ||
							item.articleType == 'Parking late' ||
							item.articleType == 'Chauffeur late'
						))
						.map(item => item.amount * item.sumCosts)
						.reduce((a, b) =>  a + b, 0)

					const nonContractualAmount1 = base
						.filter(item => item.isContractual == 0 && (item.articleType == '1Day'))
						.map(item => item.amount)
						.reduce((a, b) =>  a + b, 0)

					const nonContractualCommission1 = base
						.filter(item => item.isContractual == 0 && (item.articleType == '1Day'))
						.map(item => item.sumCommission)
						.reduce((a, b) =>  a + b, 0)

					const nonContractualAmount23 = base
						.filter(item => item.isContractual == 0 && (item.articleType == '2Days' || item.articleType == '3Days'))
						.map(item => item.amount)
						.reduce((a, b) =>  a + b, 0)

					const nonContractualCommission23 = base
						.filter(item => item.isContractual == 0 && (item.articleType == '2Days' || item.articleType == '3Days'))
						.map(item => item.sumCommission)
						.reduce((a, b) =>  a + b, 0)

					const contractualAmount1 = base
						.filter(item => item.isContractual == 1 && (item.articleType == '1Day'))
						.map(item => item.amount)
						.reduce((a, b) =>  a + b, 0)
	

					const contractualCommission1 = base
						.filter(item => item.isContractual == 1 && (item.articleType == '1Day'))
						.map(item => item.sumContractualCommission)
						.reduce((a, b) =>  a + b, 0)

					const contractualAmount23 = base
						.filter(item => item.isContractual == 1 && (item.articleType == '2Days' || item.articleType == '3Days'))
						.map(item => item.amount)
						.reduce((a, b) =>  a + b, 0)

					const contractualCommission23 = base
						.filter(item => item.isContractual == 1 )
						.map(item => item.sumContractualCommission)
						.reduce((a, b) =>  a + b, 0)
	
					const result = []

					if (contractualAmount1 > 0) {
						result.push({
							type: 'Contractual comission (1 day - contractual)',
							price: contractualCommission1 / contractualAmount1,
							amount: contractualAmount1,
							total: contractualCommission1
						})
					}

					if (nonContractualAmount1 > 0) {
						result.push({
							type: 'Contractual comission (1 day)',
							price: nonContractualCommission1 / nonContractualAmount1,
							amount: nonContractualAmount1,
							total: nonContractualCommission1
						})
					}

					if (contractualAmount23 > 0) {
						result.push({
							type: 'Contractual comission (2/3 day - contractual)',
							price: contractualCommission23 / contractualAmount23,
							amount: contractualAmount23,
							total: contractualCommission23 
						})
					}
		

					if (nonContractualAmount23 > 0) {
						result.push({
							type: 'Comission (2/3 day)',
							price: nonContractualCommission23 / nonContractualAmount23,
							amount: nonContractualAmount23,
							total: nonContractualCommission23
						})
					}

					if (contractualCosts > 0) {
						result.push({
							type: 'Contractual ticket cost (1/2/3 day ticket + internally bought passes)',
							amount: '',
							total: contractualCosts
						})
					}
					
		
					return result
				} else {
					return []
				}
			}
		},
		methods: {
			getTotalCellValue (data) {
				return data.amount * data.sumCosts
			},
			getNameCellValue (data) {
				if (data['articleType'].indexOf('Commission') == -1 && data['articleType'].indexOf('Contractual commission') == -1) {
                    if (data['articleName'].indexOf('Late') !== -1) {
                        return 'Ticket costs - ' + data['articleType'] + (data['isContractual'] == 1 ? ' contractual' : '') + ' Late';
                    }
                    return 'Ticket costs - ' + data['articleType'] + (data['isContractual'] == 1 ? ' contractual' : '');
                }
                return data['articleType']
			},
		    refreshSums () {
				this.totalRevenue = this.contractualRevenuesSum + this.nonContractualRevenuesSum
				this.totalInvoice = this.nonContractualRevenuesSum - this.costsPerArticleTypeSum
			}
		},
		watch: {
			contractualRevenues (val) {
				this.contractualRevenuesSum = val.map(i => i.sumPriceTotal)
					.reduce((a, b) => a + b, 0)
				this.refreshSums()
			},
			nonContractualRevenues (val) {
				this.nonContractualRevenuesSum = val.map(i => i.sumPriceTotal)
					.reduce((a, b) => a + b, 0)
				this.refreshSums()
			},
			totalRevenuesPerArticleType (val) {
				this.totalRevenuesPerArticleTypeSum = val.map(i => i.sumPriceTotal)
					.reduce((a, b) => a + b, 0)
				this.refreshSums()
			},
			costsPerArticleType (val) {
				const contractualAmount = val
					.filter(item => item.isContractual == 1 && (item.articleType == '2Days' || item.articleType == '3Days'))
					.map(item => item.amount)
					.reduce((a, b) =>  a + b, 0)

				const nonContractualAmount = val
					.filter(item => item.isContractual == 0 && (item.articleType == '2Days' || item.articleType == '3Days'))
					.map(item => item.amount)
					.reduce((a, b) =>  a + b, 0)

				const sumContractualCommission = val
					.filter(item => item.isContractual == 1)
					.map(item => item.sumContractualCommission)
					.reduce((a, b) =>  a + b, 0)

				const sumCommission = val
					.filter(item => item.isContractual == 0)
					.map(item => item.sumCommission)
					.reduce((a, b) =>  a + b, 0)

				// if (val.length > 0) {
				// 	if (contractualAmount > 0) {
				// 		val.push({
				// 			articleType: 'Contractual commission 1% 2/3 Days',
				// 			amount: contractualAmount,
				// 			sumCosts: sumContractualCommission /contractualAmount,
				// 			sumCostsTotal: sumContractualCommission
				// 		})
				// 	}
					
				// 	if (nonContractualAmount > 0) {
				// 		// add commission not contractual Line

				// 		val.push({
				// 			articleType: 'Commission 3% 2/3 Days',
				// 			amount: nonContractualAmount,
				// 			sumCosts: sumCommission / nonContractualAmount,
				// 			sumCostsTotal: sumCommission
				// 		})
				// 	}
					
				// }

				this.costsPerArticleTypeSum = val.map(i => i.sumCostsTotal)
					.reduce((a, b) => a + b, 0)

				this.refreshSums()
			},

		},
		mounted () {
			const self = this
		}
	}
</script>
